"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
} from "@/components/ui/modal";
import { NeedsMergeQueue } from "./needs-merge-queue";
import { useNeedsMerge } from "../hooks/use-ats-needs-merge";
import { useJobAtsLink } from "../hooks/use-job-ats-link";

/**
 * The ATS "Review" (needs-merge) action for the pipeline toolbar. Renders only
 * for an ATS-linked job; shows the pending needs-merge count and opens the merge
 * queue. Relocated here from the old JobAtsHeader row.
 */
export function AtsToolbarAction({ jobId }: { jobId: string }) {
  const { isLinked } = useJobAtsLink(jobId);
  const { count } = useNeedsMerge(isLinked ? jobId : null);
  const [mergeOpen, setMergeOpen] = useState(false);

  if (!isLinked) return null;

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => setMergeOpen(true)}
      >
        Review
        {count > 0 && (
          <Badge variant="warning" size="sm" className="ml-1">
            {count} to review
          </Badge>
        )}
      </Button>

      <Modal open={mergeOpen} onOpenChange={setMergeOpen}>
        <ModalContent>
          <ModalHeader title="Review ATS candidates" />
          <ModalBody>
            <NeedsMergeQueue jobId={jobId} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
